export default "__VITE_ASSET__DbHLrnGO__"